(function () {
const $a880d368cdc53bd2$var$openButton = document.querySelector(".open-video-button");
const $a880d368cdc53bd2$var$closeButton = document.querySelector(".close-modal");
const $a880d368cdc53bd2$var$videoModal = document.querySelector(".featured-video-modal");
// const videoEmbed = document.querySelector('.featured-video-embed');
$a880d368cdc53bd2$var$openButton?.addEventListener("click", (e)=>{
    e.preventDefault();
    $a880d368cdc53bd2$var$videoModal?.classList.toggle("open");
// const iframes = document.querySelectorAll('iframe');
// if (iframes.length == 0) {
//   console.log('adding iframe');
//   const iframe = document.querySelector('iframe');
//   const vidUrl = iframe?.getAttribute('rel-iframe');
//   console.log(vidUrl);
//   iframe?.setAttribute("src", "https://youtu.be/8Se43-bWPm0");
//   // const iframe = document.createElement('iframe');
//   // iframe.src = "https://youtu.be/8Se43-bWPm0";
//   // iframe.width = "100%";
//   // iframe.height = "100%";
//   // videoEmbed?.appendChild(iframe);
// }
});
$a880d368cdc53bd2$var$closeButton?.addEventListener("click", (e)=>{
    e.preventDefault();
    const iframes = document.querySelectorAll("iframe");
    $a880d368cdc53bd2$var$videoModal?.classList.toggle("open");
    Array.prototype.forEach.call(iframes, (iframe)=>{
        iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":[]}', "*");
    });
});

})();
//# sourceMappingURL=featured-video.js.map
